import { store } from "@/services";
import { store_file } from "../../services";

/**
 * Modulo control de layout aplicacion
 */

const state = {
  products: [],
  selectProduct: {},
  brands: {},
  cartItems: [],
  loadingCartItems: false,
  pendingInvoiceOrders: [],
  billedOrders: [],
  paginationPendingOrders: {},
  paginationBilledOrders: {},
  inventoryValidation: [],
};

const getters = {
  ITEMS_PRODUCTS(state) {
    return state.products;
  },

  PENDING_INVOICE_ORDERS(state) {
    return state.pendingInvoiceOrders;
  },

  BILLED_ORDERS(state) {
    return state.billedOrders;
  },

  GET_SELECTED_PRODUCT(state) {
    return state.selectProduct;
  },

  GET_CART_ITEMS(state) {
    return state.cartItems;
  },

  GET_LOADING_CART_ITEMS(state) {
    return state.loadingCartItems;
  },

  GET_INVENTORY_VALIDATION(state) {
    return state.inventoryValidation;
  },

  GET_PAGINATION_PENDING_ORDERS(state) {
    return state.paginationPendingOrders;
  },

  GET_PAGINATION_BILLED_ORDERS(state) {
    return state.paginationBilledOrders;
  },
  GET_BRANDS(state) {
    return state.brands;
  },
};

const mutations = {
  SET_ITEM_PRODUCT(state, payload) {
    state.products = payload;
  },

  SET_ONE_PRODUCT(state, payload) {
    state.selectProduct = payload;
  },

  SET_PENDING_INVOICE_ORDERS(state, payload) {
    state.pendingInvoiceOrders = payload;
  },

  SET_BILLED_ORDERS(state, payload) {
    state.billedOrders = payload;
  },

  SET_ALL_BRANDS(state, payload) {
    state.brands = payload;
  },

  SET_CART_ITEMS(state, payload) {
    state.cartItems = payload;
  },

  SET_LOADING_CART_ITEMS(state, payload) {
    state.loadingCartItems = payload;
  },

  SET_INVENTORY_VALIDATION(state, payload) {
    state.inventoryValidation = payload;
  },

  REMOVE_ITEM_FROM_ORDER(state, itemId) {
    const itemIdx = state.inventoryValidation.products.findIndex(
      ({ id }) => id === itemId
    );
    state.inventoryValidation.products.splice(itemIdx, 1);
  },

  SET_PAGINATION_PENDING_ORDERS(state, payload) {
    state.paginationPendingOrders = payload;
  },

  SET_PAGINATION_BILLED_ORDERS(state, payload) {
    state.paginationBilledOrders = payload;
  },
  SET_BRANDS(state, payload) {
    state.brands = payload;
  },
};

const actions = {
  async GET_SHOPPING_CART({ commit }) {
    commit("SET_LOADING_CART_ITEMS", true);
    try {
      const response = await store.get(
        `/api/b2b/shopping-carts/currently-active`
      );
      commit("SET_CART_ITEMS", response.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    } finally {
      commit("SET_LOADING_CART_ITEMS", false);
    }
  },

  async ADD_PRODUCT_CART(_, payload) {
    try {
      const response = await store.post(
        "api/b2b/shopping-carts/items",
        payload
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DELETE_PRODUCT_CART(_, payload) {
    try {
      await store.delete(`/api/b2b/shopping-carts/items/${payload.item_id}`);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async EMPTY_CART(_, payload) {
    try {
      await store.delete(
        `/api/b2b/shopping-carts/empty/${payload.shopping_cart_id}`
      );
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_CURRENT_CART() {
    try {
      const response = await store.get(`/api/shooping_cart_active`);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async CONFIRM_SHOPPING_CAR({ commit }, cartId) {
    console.log(commit);
    try {
      const response = await store.get(
        `/api/b2b/shopping-carts/confirm/${cartId}`
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_PENDING_INVOICE_ORDERS({ commit }, payload) {
    try {
      const response = await store.get(
        `/api/b2b/orders/pending-billing?page=${payload.page}&per_page=${payload.per_page}`
      );
      commit(
        "SET_PENDING_INVOICE_ORDERS",
        response.data.orders.map(({ total_amount, ...rest }) => ({
          ...rest,
          total_amount: Number(total_amount).toFixed(2),
        }))
      );
      commit("SET_PAGINATION_PENDING_ORDERS", {
        lastPage: response.data.lastPage,
        page: response.data.page,
        perPage: response.data.perPage,
        total: response.data.total,
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_INVOICED_ORDERES({ commit }, payload) {
    try {
      const response = await store.get(
        `/api/b2b/orders/billed?page=${payload.page}&per_page=${payload.per_page}`
      );
      commit(
        "SET_BILLED_ORDERS",
        response.data.orders.map(({ total_amount, ...rest }) => ({
          ...rest,
          total_amount: Number(total_amount).toFixed(2),
        }))
      );
      commit("SET_PAGINATION_BILLED_ORDERS", {
        lastPage: response.data.lastPage,
        page: response.data.page,
        perPage: response.data.perPage,
        total: response.data.total,
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async GET_INVENTORY_VALIDATION({ commit }, orderId) {
    console.log(commit);
    try {
      const response = await store.get(
        `/api/b2b/orders/stock/validate/${orderId}`
      );
      const { order_stock_can_be_fulfilled, ...items } = response.data;
      commit("SET_INVENTORY_VALIDATION", {
        products: Object.values(items),
        order_stock_can_be_fulfilled,
      });
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async BILL_ORDER({ commit }, orderId) {
    console.log(commit);
    try {
      await store.get(`/api/b2b/orders/invoice/${orderId}`);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async UPDATE_ORDER({ commit }, { payload, orderId }) {
    console.log(commit);
    try {
      await store.patch(`/api/b2b/orders/stock/update/${orderId}`, payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async CANCEL_ORDER({ commit }, orderId) {
    console.log(commit);
    try {
      await store.patch(`/api/b2b/orders/cancel/${orderId}`);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async REMOVE_ITEM_FROM_ORDER({ commit }, itemId) {
    commit("REMOVE_ITEM_FROM_ORDER", itemId);
  },

  async GET_ORDER_BY_ID({ commit }, orderId) {
    console.log(commit);
    try {
      const response = await store.get(`/api/b2b/orders/detail/${orderId}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async UPLOAD_VOUCHER({ commit }, { order_id, receipt }) {
    console.log(commit);
    const formData = new FormData();
    formData.append("order_id", order_id);
    formData.append("receipt", receipt);
    await store_file.post(`api/b2b/orders/payment/upload-receipt`, formData);
  },

  async GET_BRANDS({ commit }) {
    const response = await store.get(`api/b2b/brands`);
    commit(
      "SET_BRANDS",
      response.data.data.reduce((acum, brand) => {
        acum[brand.name] = brand.id;
        return acum;
      }, {})
    );
  },
};
export const shoppingCart = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
